/**
 * Análisis financiero — módulo general.
 * No se vende aparte y no usa el entitlement «tramites» ni otra licencia.
 * Visibilidad comprador: buyer_module_visibility.analisis_financiero (default visible).
 */
export const MODULO_ANALISIS_FINANCIERO_ID = "analisis_financiero";

export const ANALISIS_FINANCIERO_PATH = "/analisis-financiero";

export const ANALISIS_FINANCIERO_CONTEXT_LABEL = "Análisis financiero";

export const MODULO_ANALISIS_FINANCIERO_CARD = {
  id: MODULO_ANALISIS_FINANCIERO_ID,
  title: "Análisis financiero",
  description:
    "Gastos razonables y proyección al cierre a partir del estado de resultados de cada empresa.",
  bullets: [
    "Carga del estado de resultados en Excel, PDF con texto o captura manual",
    "Comparación contra una tabla de referencias editable, marcada EJEMPLO",
    "Proyección al cierre (el cálculo queda para la siguiente fase)",
  ],
  entryPath: ANALISIS_FINANCIERO_PATH,
  path: ANALISIS_FINANCIERO_PATH,
  route: ANALISIS_FINANCIERO_PATH,
};

export const ANALISIS_FINANCIERO_MODULE_PATHS = new Set([ANALISIS_FINANCIERO_PATH]);

export function isAnalisisFinancieroPath(pathname) {
  const path = String(pathname || "").split("?")[0];
  return path === ANALISIS_FINANCIERO_PATH || path.startsWith(`${ANALISIS_FINANCIERO_PATH}/`);
}
